import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CUSTOMER_SERVICE_HELP_CENTER_URL } from '@features/shared/customer-service/constants/customer-service.constants';
import { IconComponent, LinkComponent } from '@fnccr-actee/design-system';
import { TranslatePipe } from '@ngx-translate/core';
import { OnboardingInfoCardComponent } from '../../ui/onboarding-info-card/onboarding-info-card.component';

@Component({
  selector: 'app-onboarding-step-four',
  imports: [OnboardingInfoCardComponent, IconComponent, LinkComponent, NgOptimizedImage, TranslatePipe],
  templateUrl: './onboarding-step-four.component.html',
  styleUrl: '../step.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingStepFourComponent {
  readonly helpCenterUrl = CUSTOMER_SERVICE_HELP_CENTER_URL;
}
